module.exports = __webpack_public_path__ + "img/gift_top_one.8ca5d8a8.png";